<div class="agent-substitution-form">
  <typography-v2 *ngIf="loading" class="text-black-50">Loading...</typography-v2>

  <ng-container *ngIf="!loading">
    <div *ngIf="!activeSubstitution" class="v2-mb-4">
      <typography-v2 class="text-black-50 v2-mb-2">
        Choose who handles your work while you're away.
      </typography-v2>
      <typography-v2>No one is covering for you</typography-v2>
    </div>

    <form
      [formGroup]="formGroup"
      (ngSubmit)="activateSubstitution()"
      (keydown.enter)="$event.preventDefault()"
    >
      <formly-form [form]="formGroup" [model]="formModel" [fields]="fields"></formly-form>

      <div class="d-flex justify-content-end v2-mt-5">
        <button-v2
          *ngIf="activeSubstitution"
          type="destructive"
          buttonType="button"
          [disabled]="submitting"
          (click)="cancelSubstitution()"
        >
          End coverage
        </button-v2>

        <button-v2
          *ngIf="!activeSubstitution"
          buttonType="submit"
          [disabled]="!formGroup.valid || submitting"
        >
          Start coverage
        </button-v2>
      </div>
    </form>
  </ng-container>
</div>
